import React, { useState } from "react";
import { Avatar } from "@mui/material";
import BaseCard from "../../../components/ui/BaseCard";
import BaseButton from "../../../components/ui/BaseButton";
import { UserType } from "../../../utils/enum";
import { useSelector } from "react-redux";
import { serviceDesk } from "../../../utils/variables";
import EditContactsModal from "../components/EditContactsModal";
import UserProfileLink from "../../../components/ui/UserProfileLink";
import { formatPhoneNumber } from "../../../utils/helpers";

const Contacts = ({ contacts, workOrderManager, authRole, workOrderId, hasUpdateAccess }) => {
  const [isEditContactsModalOpen, setIsEditContactsModalOpen] = useState(false);
  return (
    <BaseCard className="pt-4 pb-6 xl:px-16 px-5 rounded-lg !mb-[0px]" elevation={1}>
      <div className="border-bottom mb-4 flex items-center pb-1">
        <h6 className="text-dark">Contacts</h6>
        {(authRole === UserType.CLIENT || authRole === UserType.CUSTOMER) && hasUpdateAccess && (
          <i
            className="fa-light fa-pencil text-gray-900 ml-3 cursor-pointer"
            onClick={() => setIsEditContactsModalOpen(true)}
          ></i>
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-12 mt-6">
        {/* No manager yet (a submitted ticket has none) — drop the whole box rather
            than leaving an empty one behind. */}
        {workOrderManager && (
          <div className="bg-light pt-3 pb-6 px-4 rounded-lg">
            <p className="text-lg font-normal mb-1">Work Order Manager</p>
            <UserProfileLink
              as="div"
              userId={workOrderManager?.id}
              className="flex items-center gap-2 mb-1 w-fit"
              linkClassName="cursor-pointer group"
            >
              <Avatar
                src={workOrderManager?.profilePicture}
                alt={workOrderManager?.firstName}
                sx={{ width: 28, height: 28, fontSize: 12 }}
              >
                {workOrderManager?.firstName?.[0]}
                {workOrderManager?.lastName?.[0]}
              </Avatar>
              <p className="text-primary capitalize group-hover:underline">
                {workOrderManager?.firstName}
              </p>
            </UserProfileLink>
            <p className="text-primary mb-1">{formatPhoneNumber(workOrderManager?.phoneNumber)}</p>
            <p className="text-primary mb-1 break-all">{workOrderManager?.email}</p>
          </div>
        )}
        {serviceDesk && (
          <div className="bg-light pt-3 pb-6 px-4 rounded-lg">
            <p className="text-lg font-normal mb-1">{serviceDesk.name}</p>
            <p className="mb-1">{serviceDesk.position}</p>
            <p className="text-primary mb-1">{formatPhoneNumber(serviceDesk.phone)}</p>
            <p className="text-primary mb-1 break-all">{serviceDesk.email}</p>
            <p className="mb-1 text-sm">Note: {serviceDesk.note}</p>
          </div>
        )}
        {contacts?.map((contact, index) => (
          <div className="bg-light pt-3 pb-6 px-4 rounded-lg" key={index}>
            <p className="text-lg font-normal mb-1">{contact?.position}</p>
            <p className="mb-1">{contact?.name}</p>
            <p className="text-primary mb-1">{formatPhoneNumber(contact?.phoneNumber)}</p>
            <p className="text-primary mb-1 break-all">{contact?.email}</p>
            {contact?.note && <p className="mb-1 text-sm">Note: {contact?.note}</p>}
          </div>
        ))}
      </div>
      {isEditContactsModalOpen && (
        <EditContactsModal
          open={isEditContactsModalOpen}
          close={() => setIsEditContactsModalOpen(false)}
          contacts={contacts}
          workOrderManager={workOrderManager}
          workOrderId={workOrderId}
        />
      )}
    </BaseCard>
  );
};

export default Contacts;
